import { Col, Form, Input, Row } from "antd";
import React, { useEffect, useState } from "react";
import { ButtonProps } from "../../helpers/constants";
import useAxiosPost from "../../hooks/useAxiosPost";
import useMultiNotification from "../../hooks/useNotification";
import NetwalaButton from "../Items/Button/Index";
import NetwalaModal from "../Items/Modal/Index";
import NetwalaSelect from "../Items/Select/Index";
import "./styles/RequestIPTVModal.css";
const UpdateCATVConnectionModal: React.FC<UpdateConnectionModalProp> = ({
  show,
  handleClose,
  connection,
}) => {
  const [form] = Form.useForm();

  const { openNotification, contextHolder } = useMultiNotification();
  const [selectedArea, setSelectedArea] = useState("");
  const [selectedSubArea, setSelectedSubArea] = useState<null | string>(null);
  const [areas, setAreas] = useState<NetwalaSelectOptions[]>([]);
  const [subAreas, setSubAreas] = useState<NetwalaSelectOptions[]>([]);
  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<UpdateCATVConnectionApiProp>(
    "connections/updateCATVConnectionDetails",
    true
  );

  const [
    getAreasApi,
    areasApiResponse,
    areasApiError,
    areasApiLoading,
    areasApiMessage,
    areasApiErrorCount,
  ] = useAxiosPost<ResponseProp>("areas/getAreasByOwner");
  const [
    getSubAreasApi,
    subAreasApiResponse,
    subAreasApiError,
    subAreasApiLoading,
    subAreasApiMessage,
    subAreasApiErrorCount,
  ] = useAxiosPost<SubAreasByAreaIDApiProp>("areas/getSubAreasByAreaID");

  useEffect(() => {
    if (connection.parent_intPkAreaID) {
      getSubAreasApi({ intPkAreaID: connection.parent_intPkAreaID });
    } else {
      getSubAreasApi({ intPkAreaID: connection.intPkAreaID });
    }
    getAreasApi({});
  }, []);

  useEffect(() => {
    if (areasApiResponse !== null) {
      const data: any = areasApiResponse.responseData;
      const areas = data.map((item: any): NetwalaSelectOptions => {
        return {
          value: item.intPkAreaID,
          label: item.areaName,
        };
      });

      setAreas(areas);
    }
  }, [areasApiResponse]);
  useEffect(() => {
    if (subAreasApiResponse !== null) {
      const data: any = subAreasApiResponse.responseData;
      const subAreas = data.map((item: any): NetwalaSelectOptions => {
        return {
          value: item.intPkAreaID,
          label: item.areaName,
        };
      });

      setSubAreas(subAreas);
    }
  }, [subAreasApiResponse]);

  const onFinish = (values: any) => {
    const { sale_price, address, area, subArea } = values;
    const dataToSend: UpdateCATVConnectionApiProp = {
      intPkConnectionID: connection.intPkConnectionID,
      address,
      sale_price: Number(sale_price),
      firstName: values.firstName,
      lastName: values.lastName,
      phoneNumber: values.phoneNumber,
      nicNumber: values.nicNumber || null,
      areaId: subArea ? subArea : area,
    };
    postApiData(dataToSend);
  };
  useEffect(() => {
    if (apiResponse !== null) {
      const { message } = apiResponse;
      if (message) {
        openNotification("success", "Success", message);
        setTimeout(() => {
          handleClose(true);
        }, 2500);
      }
    }
  }, [apiResponse]);
  useEffect(() => {
    if (apiError !== null && apiErrorCount !== 0) {
      openNotification("error", "Error", apiError);
    }
  }, [apiError, apiErrorCount]);

  const onFinishFailed = (errorInfo: any) => {};

  const handleAreaChange = (value: string) => {
    setSelectedSubArea(null);
    form.setFieldsValue({ subArea: undefined });

    getSubAreasApi({ intPkAreaID: Number(value) });
  };
  return (
    <>
      <NetwalaModal
        title="Update CATV Connection"
        headerStyle={{
          backgroundColor: "#292D8E",
          color: "#FFFFFF",
          fontSize: "16px",
          fontWeight: "400",
          height: "50px",
        }}
        open={show}
        onCancel={() => {
          handleClose(false);
        }}
      >
        {contextHolder}
        <Row>
          <Col span={24} className="iptv-modal-package-details">
            <Form
              requiredMark={false}
              style={{ width: "100%", marginTop: "50px" }}
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              form={form}
              name="updateCATVConnectionForm"
              initialValues={{
                sale_price: connection.sale_price,
                address: connection.address,
                firstName: connection.firstName,
                lastName: connection.lastName,
                phoneNumber: connection.phoneNumber,
                nicNumber: connection.nicNumber || "",
                subArea: connection.parent_intPkAreaID
                  ? connection.intPkAreaID
                  : null,
                area: connection.parent_intPkAreaID
                  ? connection.parent_intPkAreaID
                  : connection.intPkAreaID,
              }}
            >
              <Form.Item
                label={
                  <span className="create-user-form-label">First Name</span>
                }
                name="firstName"
                getValueFromEvent={(e) => e.target.value.trimStart()} // trims start spaces as user types
                rules={[
                  {
                    required: true,
                    message: "Please enter First Name",
                  },
                  {
                    pattern: /^[A-Za-z0-9 ]+$/,
                    message: "Only letters, numbers, and spaces are allowed",
                  },
                  {
                    validator: (_, value) => {
                      if (value && value.trim().length === 0) {
                        return Promise.reject("Name cannot be just spaces");
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="John"
                  onBlur={(e) => {
                    e.target.value = e.target.value.trim(); // trim on blur
                  }}
                />
              </Form.Item>
              <Form.Item
                label={
                  <span className="create-user-form-label">Last Name</span>
                }
                name="lastName"
                getValueFromEvent={(e) => e.target.value.trimStart()}
                rules={[
                  {
                    required: true,
                    message: "Please enter Last Name",
                  },
                  {
                    pattern: /^[A-Za-z0-9 ]+$/,
                    message: "Only letters, numbers, and spaces are allowed",
                  },
                  {
                    validator: (_, value) => {
                      if (value && value.trim().length === 0) {
                        return Promise.reject("Name cannot be just spaces");
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="Doe"
                  onBlur={(e) => {
                    e.target.value = e.target.value.trim();
                  }}
                />
              </Form.Item>
              <Form.Item
                label={
                  <span className="create-user-form-label">Phone Number</span>
                }
                name="phoneNumber"
                rules={[
                  {
                    required: true,
                    message: "Please enter Phone number",
                  },
                  {
                    pattern: /^(?:\+92|0)?3[0-9]{9}$/,
                    message: "Please enter a valid Pakistani phone number",
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="03001235467"
                />
              </Form.Item>

              <Form.Item
                label={
                  <span className="create-user-form-label">NIC Number</span>
                }
                name="nicNumber"
              >
                <Input
                  className="user-input-general-height"
                  placeholder="12345-1234567-1"
                />
              </Form.Item>

              <Form.Item
                label={<span className="create-user-form-label">Address</span>}
                name="address"
                rules={[
                  {
                    required: true,
                    message: "Please enter Address",
                  },
                  {
                    validator: (_, value) => {
                      if (value) {
                        if (value.includes("'")) {
                          return Promise.reject(
                            "Address cannot contain single quote (') character"
                          );
                        }
                        if (value.includes("--")) {
                          return Promise.reject(
                            "Address cannot contain (--) pattern "
                          );
                        }
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="House No."
                />
              </Form.Item>
              <Form.Item
                label={
                  <span className="create-user-form-label">Sale Price</span>
                }
                name="sale_price"
                rules={[
                  {
                    required: true,
                    message: "Please enter Sale Price",
                  },
                  {
                    validator: (_, value) =>
                      value > 0
                        ? Promise.resolve()
                        : Promise.reject(
                            new Error("Sale Price must be greater than 0")
                          ),
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="300"
                  type="number"
                />
              </Form.Item>
              <Form.Item
                label={<span className="create-user-form-label">Area</span>}
                name="area"
                rules={[
                  {
                    required: true,
                    message: "Please Select Area",
                  },
                ]}
              >
                <NetwalaSelect
                  showSearch
                  value={selectedArea}
                  onChange={handleAreaChange}
                  size="large"
                  height="45px"
                  options={areas}
                  allowClear
                />
              </Form.Item>

              <Form.Item
                label={<span className="create-user-form-label">Sub Area</span>}
                name="subArea"
                // rules={[
                //   {
                //     required: true,
                //     message: "Please enter Sub Area",
                //   },
                // ]}
              >
                <NetwalaSelect
                  showSearch
                  value={selectedSubArea}
                  size="large"
                  height="45px"
                  options={subAreas}
                  allowClear
                />
              </Form.Item>

              <Form.Item>
                <NetwalaButton
                  backgroundColor={ButtonProps.background.YELLOW}
                  height={ButtonProps.height.STANDARD}
                  width={`100%`}
                  textColor={ButtonProps.color.STANDARD}
                  onClick={() => {}}
                  htmlType="submit"
                  text="Submit"
                  borderColor="#FFA726"
                  disabled={apiLoading}
                />
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </NetwalaModal>
    </>
  );
};

export default UpdateCATVConnectionModal;
